import {
  GET_ALL_INVOICES_REQUEST,
  GET_ALL_INVOICES_SUCCESS,
  GET_ALL_INVOICES_FAILURE,
} from "../../../redux/types/auth"

const initialState = {
  loading: false,
  data: [],
  error: null,
  success: false,
}

const getAllInvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_INVOICES_REQUEST:
      return {
        loading: true,
        error: null,
        success: false,
        data: state.data,
      }
    case GET_ALL_INVOICES_SUCCESS:
      return {
        loading: false,
        data: action.payload && action.payload.data ? action.payload.data : [],
        error: null,
        success: true,
      }
    case GET_ALL_INVOICES_FAILURE:
      return {
        loading: false,
        data: state.data,
        error:
          (action.payload && action.payload.error) ||
          "Failed to load invoice data",
        success: false,
      }
    default:
      return state
  }
}

export default getAllInvoicesReducer
